import React from 'react';
import siteDetels from '../data/setting/siteDetels.json';


export default function SiteName() {
    return (
        <>
            {siteDetels.siteName}
        </>
    )
}